export default "__VITE_ASSET__C$x46P2O__"